<template>
  <div>
    <div class="loan-title" @click="openedModal = !openedModal">Рассрочка 0%</div>
    <div class="bd-modal-backdrop" v-show="openedModal" @click="openedModal=!openedModal"></div>
    <div class="bd-modal loan-modal" v-show="openedModal">
      <div class="bd-modal-close" @click="openedModal=!openedModal"></div>

      <div class="loan-text-title">Не хватает на отдых?</div>
      <div class="loan-desc">Горящий тур в рассрочку без переплаты!</div>
      <div class="loan-footer">
        <div class="loan-phone" v-text="phone"></div>
        <div class="loan-footer-text">Звоните, чтобы узнать детали 0% рассрочки</div>
      </div>

    </div>
    </div>
</template>
<script>
export default {
  name: "hot-loans",
  props: ['phone'],
  data() {
    return {
      openedModal: false
    }
  },
  mounted() {

  },
  methods: {


  },
}
</script>
